export function mapMenuItemsForMenubar(
  items = [],
  {
    template,
    resolvePath,
    navigateTo,
    resolveCommand,
  } = {},
) {
  return (items || []).map((item) => {
    const hasChildren = Array.isArray(item.items) && item.items.length > 0

    const mapped = {
      label: item.label,
      icon: item.icon,
    }

    if (template) {
      mapped.template = template
    }

    const customCommand = resolveCommand?.(item)
    if (!hasChildren && customCommand) {
      mapped.command = customCommand
    } else if (!hasChildren && item.path && navigateTo) {
      const finalPath = resolvePath ? resolvePath(item.path, item) : item.path
      mapped.command = () => navigateTo(finalPath, item)
    }

    if (hasChildren) {
      mapped.items = mapMenuItemsForMenubar(item.items, {
        template,
        resolvePath,
        navigateTo,
        resolveCommand,
      })
    }

    return mapped
  })
}